import type { FunctionComponent } from 'react';

import { Button, ThemeProvider, time } from '@dr.pogodin/react-utils';

import FiveFaces from 'components/website/FiveFaces';
import Separator from 'components/website/Separator';

import { P_ADMIN_CONTENT_MANAGEMENT, useGlobalState } from 'utils';

import bgCollectiveUrl from 'assets/images/bg-collective.png';
import IconPlus from 'assets/images/icon-plus-24px.svg';

import buttonTheme from 'themes/Button/website/primary-34px.scss';

import './style.scss';
import ctaButtonTheme from './cta-button-theme.scss';

const WelcomeBanner: FunctionComponent = () => {
  const [user] = useGlobalState('user');
  if (!user) throw Error('Not authenticated');

  if (!user.createdAt) throw Error('Internal error');
  const memberSince = time(user.createdAt).year();

  return (
    <div
      style={{ backgroundImage: `url(${bgCollectiveUrl})` }}
      styleName="container"
    >
      <div styleName="main">
        <h1 styleName="greeting">Hi, {user.firstName}</h1>
        <h2 styleName="subtitle">
          Welcome to Soul Sanctuary&apos;s founding collective
        </h2>
        <Separator color="#F48420" />
        <p>
          As part of our global collective of practitioners,
          you&apos;re not just uploading videos&nbsp;&mdash;
          you&apos;re creating transformational
          experiences through the power of micro-practices.
        </p>
        <div styleName="pills">
          {memberSince <= 2025 ? (
            <>
              <span styleName="pill">Founding Member</span>
              <span styleName="dot">&bull;</span>
            </>
          ) : null}
          <span styleName="pill">Member since {memberSince}</span>
        </div>
        <div styleName="facesWrapper">
          <FiveFaces />
        </div>
        <ThemeProvider themes={{ Button: buttonTheme }}>
          <Button
            styleName="ctaButton"
            theme={ctaButtonTheme}
            to={P_ADMIN_CONTENT_MANAGEMENT}
          >
            <IconPlus styleName="ctaIcon" />
            Start Creating Content
          </Button>
        </ThemeProvider>
      </div>
    </div>
  );
};

export default WelcomeBanner;
